import React, { useEffect, useMemo, useState } from 'react'
import { Switch, Route, useHistory, useLocation } from 'react-router-dom'
import {
  useDispatch,
  useFlowContext,
  useFlowManager,
  useSignupState
} from '../../../hooks'
import { StepNames } from '../../../types'
import { updateSignupSession } from '../../../actions'
import { ErrorPage } from '../ErrorPage'

const { START_STEP } = StepNames

export const FlowManagerRoutes = () => {
  const history = useHistory()
  const location = useLocation()
  const flowContext = useFlowContext()
  const flowManager = useFlowManager()
  const dispatch = useDispatch()
  const signupState = useSignupState()
  const partialSubscriptionState = signupState.partialSubscription
  const { currentStep, basePath } = signupState.signupSession
  const [isFinished, finalStepPath] = useMemo(
    () => [
      flowManager.isFinished(signupState),
      flowManager.finalPath(signupState)
    ],
    [flowManager, signupState]
  )
  const [ready, setReady] = useState(false)
  const isV3PostOobe =
    partialSubscriptionState.data?.flowName === 'v3_post_oobe'

  useEffect(() => {
    if (!ready) {
      if (currentStep) {
        if (partialSubscriptionState.data) {
          const targetPath = isFinished ? finalStepPath : currentStep
          if (isV3PostOobe && location.pathname === targetPath) {
            setReady(true)
          } else {
            history.replace(targetPath)
            setReady(true)
          }
        }
      } else {
        const targetPath = flowManager.pathFromStep(START_STEP)
        if (isV3PostOobe && location.pathname === targetPath) {
          setReady(true)
        } else {
          history.replace({
            pathname: targetPath,
            search: location.search
          })
          setReady(true)
        }
      }
    }
  }, [
    ready,
    currentStep,
    history,
    flowManager,
    partialSubscriptionState.data,
    location.search,
    isFinished,
    finalStepPath,
    location.pathname,
    isV3PostOobe
  ])

  useEffect(() => {
    if (
      ready &&
      isFinished &&
      location.pathname.startsWith(basePath) &&
      location.pathname !== finalStepPath
    ) {
      setTimeout(() => history.replace(finalStepPath), 0)
    }
  }, [ready, location.pathname, isFinished, history, finalStepPath, basePath])

  useEffect(() => {
    if (ready && location.pathname !== basePath) {
      ;(async () => {
        await dispatch(
          updateSignupSession({
            currentStep: location.pathname
          })
        )
      })()
    }
  }, [ready, location.pathname, basePath, dispatch])

  if (!ready) {
    if (partialSubscriptionState.error) {
      return <ErrorPage stateErrors={[partialSubscriptionState]} />
    }
    return null
  }

  const { Container } = flowContext.getComponents()
  return (
    <Switch>
      <Container>
        {Object.values(flowManager.getSteps()).map(
          ({ key, path, component: Component, props = {} }) =>
            path &&
            Component && (
              <Route key={key} path={path} exact>
                <Component props={props} />
              </Route>
            )
        )}
      </Container>
    </Switch>
  )
}
